import { createSlice } from "@reduxjs/toolkit";
const initState = {
    loading: false,
    isEditPlanSelect: true,
    isEditShippingAddress: false,
    isEditShippingMethod: false,
    isEditPaymentMethod: false,
    openValidateAddressDrawer: false,
    validateAddressDrawerState: {
        invalid: false,
        changed: false,
    },
    bannerData: {
        copy: "",
        code: "",
    },
    isInfluencer: false,
    isUpdatingCart: false,
    checkoutSegment: "",
};
const checkoutComponentSlice = createSlice({
    name: "checkoutComponent",
    initialState: initState,
    reducers: {
        toggleLoading(state) {
            state.loading = !state.loading;
        },
        setEditShippingAddress(state, action) {
            state.isEditShippingAddress = action.payload;
        },
        setEditShippingMethod(state, action) {
            state.isEditShippingMethod = action.payload;
        },
        setEditPaymentMethod(state, action) {
            state.isEditPaymentMethod = action.payload;
        },
        setOpenValidateAddressDrawer(state, action) {
            state.openValidateAddressDrawer = action.payload;
            return state;
        },
        setValidateAddressDrawerState(state, action) {
            state.validateAddressDrawerState = action.payload;
            return state;
        },
        setBannerData(state, action) {
            state.bannerData = action.payload;
            return state;
        },
        setIsInfuencer(state, action) {
            state.isInfluencer = action.payload;
            return state;
        },
        setIsUpdatingCart(state, action) {
            state.isUpdatingCart = action.payload;
            return state;
        },
        setCheckoutSegment(state, action) {
            state.checkoutSegment = action.payload;
            return state;
        },
        setIsEditPlanSelect(state, action) {
            state.isEditPlanSelect = action.payload;
            return state;
        }
    },
});
export const { toggleLoading, setEditShippingAddress, setEditPaymentMethod, setEditShippingMethod, setOpenValidateAddressDrawer, setValidateAddressDrawerState, setBannerData, setIsInfuencer, setIsUpdatingCart, setCheckoutSegment, setIsEditPlanSelect } = checkoutComponentSlice.actions;
export default checkoutComponentSlice.reducer;
